import { Box, ColorOptions, convertHexToRGBA, IconButton, Spacer, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { FC, useEffect, useState } from 'react'
import { FlatList, Platform } from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { getFilterList } from '../../screens/Payments/helper'
import { Colors } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { TextInputWithLabelOnBorder } from '../TextInputWithLabelOnBorder'
import { DateRangeSelector } from './DateRangeSelector'
import { FilterItem } from './FilterItem'
import { sectionStyles, styles } from './styles'
import { filterTypes, SectionListProps, sectionVisible } from './types'

const regex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/

const SectionList: FC<SectionListProps> = ({
  onPress,
  updateMin,
  updateMax,
  selectedFilteredData,
  updateFilters,
  filterData,
  filterHeader,
  checkSelected,
  filtersStrings,
  updateFilterSettings,
  updateDate,
  apply,
  selectedDateInfo,
  clearFilters,
}: SectionListProps) => {
  const [initialState, setInitialState] = useState(0)
  const [visibleSection, setVisibleSection] = useState('1')
  const [initialData, setInitialData] = useState<any>({})
  const [dateLabel, setDateLabel] = useState(selectedDateInfo?.dateLabel)
  const filterListData = getFilterList(selectedFilteredData)

  useEffect(() => {
    if (initialState < 1) {
      setInitialData(selectedFilteredData)
    }
  }, [initialState, selectedFilteredData])

  const updateHandler = (mode: filterTypes, value: string): void => {
    setInitialState((prev: number): number => prev + 1)
    updateFilters(mode, value)
  }

  const handleCancel = (): void => {
    updateFilterSettings({ ...initialData })
    onPress()
  }
  const handleMin = (value: string): void => {
    setInitialState((prev: number): number => prev + 1)
    updateMin(value)
  }

  const handleMax = (value: string): void => {
    setInitialState((prev: number): number => prev + 1)
    updateMax(value)
  }

  const handleApply = (): void => {
    apply()
  }

  const handleClearAll = () => {
    clearFilters()
    onPress()
  }

  const openSection = (value: string) => {
    setVisibleSection(value)
  }

  const filtersArr = [
    {
      id: '1',
      value: 'Payment Methods',
    },
    {
      id: '2',
      value: 'Status',
    },
    {
      id: '3',
      value: 'Amount Range',
    },
    {
      id: '4',
      value: 'By Date',
    },
  ]

  const updateDateRange = (dateObj: any) => {
    setDateLabel(dateObj?.dateLabel ?? '')
    updateDate(dateObj)
  }

  const calendar = selectedFilteredData.selectedDateInfo
  const invalidDate = () => {
    if (filterListData?.length && calendar?.dateLabel !== 'Custom Range') {
      return false
    } else if (
      (!calendar?.fromDate &&
        !calendar?.toDate &&
        isEmpty(initialData?.min) &&
        isEmpty(initialData?.max) &&
        initialData?.transactionStatus?.length < 1 &&
        initialData?.paymentMode?.length < 1) ||
      (calendar?.dateLabel === 'Custom Range' && !calendar?.fromDate && !calendar?.toDate)
    ) {
      return true
    } else if (
      (calendar?.dateLabel === 'Custom Range' && !isEmpty(calendar?.fromDate),
      !isEmpty(calendar?.fromDate),
      !!regex?.test(calendar?.fromDate),
      !!regex?.test(calendar?.fromDate))
    ) {
      return false
    }
  }

  const disableBtn = invalidDate()
  const rupeeComp = (val: string) => {
    return (
      <Text
        fontSize={16}
        fontFamily={'SourceSans-Medium'}
        color={Colors.BLACK_14 as ColorOptions}
        title={'₹'}
        lineHeight={24}
        opacity={isEmpty(val) ? 0.5 : 1}
      />
    )
  }
  return (
    <Box {...styles.container} testID="filters">
      <Box {...styles.closeBox} flexDirection={'row'}>
        <Text textAlign="left" fontSize={24} fontFamily={'JioType-Black'} lineHeight={32} letterSpacing={-0.12}>
          {'Filters'}
        </Text>
        <IconButton size={24} id="CLOSE" onPress={handleCancel} testID="close-filter" color={'BLACK'} />
      </Box>
      <Box flexDirection={'row'}>
        <Box f={0.42} bg={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}>
          <FlatList
            data={filtersArr}
            renderItem={({ item, index }) => (
              <Box
                {...sectionStyles(visibleSection, item?.id).sectionBox}
                testID={'open-filter-' + item?.id}
                onPress={() => openSection(item?.id)}>
                <Text {...sectionStyles(visibleSection, item?.id).sectionText}>{item?.value}</Text>
              </Box>
            )}
          />
        </Box>
        <Box f={0.58} h={Platform.OS === 'ios' ? 450 : 320}>
          <KeyboardAwareScrollView
            showsVerticalScrollIndicator={false}
            keyboardDismissMode="interactive"
            keyboardShouldPersistTaps="handled"
            scrollEnabled={true}
            enableAutomaticScroll={Platform.OS === 'ios'}
            automaticallyAdjustKeyboardInsets={true}
            keyboardOpeningTime={Number.MAX_SAFE_INTEGER}
            enableResetScrollToCoords={false}
            extraHeight={120}
            enableOnAndroid={true}>
            <FilterItem
              show={visibleSection === sectionVisible.payMethods || visibleSection === sectionVisible.status}
              header={visibleSection === sectionVisible.status ? filterHeader[1] : filterHeader[0]}
              filterData={filterData}
              updateFilters={updateHandler}
              mode={visibleSection === sectionVisible.status ? filterTypes.transactionStatus : filterTypes.paymentMode}
              checkSelected={checkSelected}
            />
            <ModBox show={visibleSection === sectionVisible.amount} {...styles.inputContainer}>
              <Spacer direction="vertical" size={12} />
              <TextInputWithLabelOnBorder
                type="NUM_ONLY"
                fieldName={'min'}
                setFieldValue={(_, val) => handleMin(val)}
                value={selectedFilteredData?.min ?? filtersStrings.empty}
                label={filtersStrings.labelMin}
                testID={filtersStrings.testIdMin}
                leftComponent={rupeeComp(selectedFilteredData?.min)}
                selectionColor={Colors.PRIMARY}
                keyboardType="number-pad"
              />
              <Spacer direction="vertical" size={24} />
              <TextInputWithLabelOnBorder
                type="NUM_ONLY"
                value={selectedFilteredData?.max ?? filtersStrings.empty}
                label={filtersStrings.labelMax}
                testID={filtersStrings.testIdMax}
                setFieldValue={(_, val) => handleMax(val)}
                fieldName={'max'}
                leftComponent={rupeeComp(selectedFilteredData?.max)}
                selectionColor={Colors.PRIMARY}
                keyboardType="number-pad"
              />
              <Spacer direction="vertical" size={12} />
            </ModBox>
            <ModBox show={visibleSection === sectionVisible.date}>
              <DateRangeSelector
                selectedFilteredData={selectedFilteredData}
                onDateRangeChange={updateDateRange}
                selectedDateInfo={selectedDateInfo}
              />
            </ModBox>
          </KeyboardAwareScrollView>
        </Box>
      </Box>
      <Box {...styles.buttonCon}>
        <Box
          onPress={handleClearAll}
          testID="clear-all-filter"
          width={148}
          align={'center'}
          justify={'center'}
          pv={16}
          underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
          borderRadius={100}
          borderWidth={1}
          disabled={disableBtn}
          opacity={disableBtn ? 0.5 : 1}
          borderColor={'PRIMARY'}>
          <Text
            title={'Clear All'}
            fontFamily={'JioType-Medium'}
            fontSize={16}
            letterSpacing={-0.08}
            color={'PRIMARY'}
          />
        </Box>
        <Spacer direction={'horizontal'} size={16} />
        <Box
          disabled={disableBtn}
          onPress={handleApply}
          testID="apply-filter"
          width={148}
          pv={16}
          align={'center'}
          justify={'center'}
          underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
          borderRadius={100}
          opacity={disableBtn ? 0.5 : 1}
          bg={'PRIMARY'}>
          <Text title={'Apply'} fontFamily={'JioType-Medium'} fontSize={16} letterSpacing={-0.08} color={'WHITE'} />
        </Box>
      </Box>
    </Box>
  )
}

export { SectionList }
